export default __webpack_public_path__ + "static/media/sketchapp.a198a515.svg";